// extracted by mini-css-extract-plugin
export default {"confirmPaymentWrapper":"confirmPaymentTemplate_confirmPaymentWrapper__YBKER"};